/**
 * 会员机构名录实质差异覆盖（以 docs/数据.xlsx 为准）
 * 仅覆盖地址/电话/业务范围等实质字段，不含纯格式差异。
 * 按许可证号优先匹配，其次机构名称。
 */
export const memberInstitutionOverridesByLicense = {
  "440302018": {
    "YWFW": "[02]法医临床鉴定（[0201]人体损伤程度鉴定、[0202]人体残疾等级鉴定、[0203]赔偿相关鉴定、[0206]诈伤、诈病、造作伤鉴定、[0209]与人体损伤相关的其他法医临床鉴定）；[01]文书鉴定（[0101]笔迹鉴定、[0102]印章印文鉴定、[0103]印刷文件鉴定、[0104]篡改（污损）文件鉴定、[0105]文件形成方式鉴定、[0106]特种文件鉴定、[0107]朱墨时序鉴定、[0109]基于痕迹特征的文件形成时间鉴定、[0111]文本内容鉴定）；[02]痕迹鉴定（[0201]手印鉴定、[0202]潜在手印显现、[0203]足迹鉴定、[0204]工具痕迹鉴定、[0205]整体分离痕迹鉴定）；[01]录音鉴定（[0101]录音处理、[0102]录音真实性鉴定、[0103]录音同一性鉴定）；[02]图像鉴定（[0201]图像处理、[0202]图像真实性鉴定、[0203]图像同一性鉴定）；[03]电子数据鉴定（[0301]电子数据存在性鉴定）"
  },
  "440303056": {
    "YWFW": "[01]法医病理鉴定；[02]法医临床鉴定；[03]法医精神病鉴定（[0301]精神状态鉴定、[0302]刑事类行为能力鉴定、[0303]民事类行为能力鉴定、[0304]其他类行为能力鉴定、[0305]精神损伤类鉴定、[0309]与心理、精神相关的其他法医精神病鉴定或测试）；[04]法医物证鉴定（[0401]个体识别、[0402]三联体亲子关系鉴定、[0403]二联体亲子关系鉴定、[0404]亲缘关系鉴定[祖孙关系鉴定、生物学全同胞关系鉴定]）；[05]法医毒物鉴定；[01]文书鉴定；[02]痕迹鉴定（[0201]手印鉴定、[0202]潜在手印显现、[0203]足迹鉴定、[0204]工具痕迹鉴定、[0205]整体分离痕迹鉴定、[0207]爆炸痕迹鉴定、[0208]火灾痕迹鉴定、[0209]人体特殊痕迹鉴定、[0210]日用物品损坏痕迹鉴定、[0211]交通事故痕迹物证鉴定）；[03]微量物证鉴定（[0301]化工产品类鉴定、[0302]金属和矿物类鉴定、[0303]纺织品类鉴定、[0304]日用化学品类鉴定、[0305]文化用品类鉴定、[0307]易燃物质类鉴定、[0310]交通事故微量物证鉴定、[0311]火灾微量物证鉴定）；[01]录音鉴定（[0101]录音处理、[0102]录音真实性鉴定、[0103]录音同一性鉴定、[0104]录音内容分析）；[02]图像鉴定（[0201]图像处理、[0202]图像真实性鉴定、[0203]图像同一性鉴定、[0204]图像内容分析）；[03]电子数据鉴定；[02]地表水与沉积物环境损害鉴定（[0201]污染环境行为致地表水与沉积物环境损害鉴定）；[05]近岸海洋与海岸带环境损害鉴定；[06]生态系统环境损害鉴定（[0601]生态破坏行为致植物损害鉴定、[0602]生态破坏行为致动物损害鉴定、[0604]生态破坏行为致森林生态系统损害鉴定、[0608]生态破坏行为致海洋生态系统损害鉴定、[0609]生态破坏行为致河流、湖泊生态系统损害鉴定、[0611]生态破坏行为致农田生态系统损害鉴定、[0612]生态破坏行为致城市生态系统损害鉴定、[0613]矿产资源开采行为致矿山地质环境破坏、土地损毁及生态功能损害鉴定）"
  },
  "440305110": {
    "JGZSXXDZ": "深圳市兴海大道信利康大厦13F"
  },
  "440309166": {
    "YWFW": "[01]法医病理鉴定（[0101]死亡原因鉴定、[0102]器官组织法医病理学检验与诊断、[0103]死亡方式判断、[0104]死亡时间推断、[0105]损伤时间推断、[0106]致伤物推断、[0107]成伤机制分析）；[02]法医临床鉴定（[0201]人体损伤程度鉴定、[0202]人体残疾等级鉴定、[0203]赔偿相关鉴定、[0206]诈伤、诈病、造作伤鉴定、[0207]医疗损害鉴定、[0209]与人体损伤相关的其他法医临床鉴定）；[01]文书鉴定（[0101]笔迹鉴定、[0102]印章印文鉴定、[0103]印刷文件鉴定、[0104]篡改（污损）文件鉴定、[0105]文件形成方式鉴定、[0107]朱墨时序鉴定、[0111]文本内容鉴定）；[03]电子数据鉴定（[0301]电子数据存在性鉴定）"
  },
  "440316236": {
    "JGZSXXDZ": "深圳市南山区梦海大道中粮亚太大厦东塔24层2403"
  },
  "440317281": {
    "YWFW": "[02]法医临床鉴定（[0201]人体损伤程度鉴定、[0202]人体残疾等级鉴定、[0203]赔偿相关鉴定、[0207]医疗损害鉴定、[0209]与人体损伤相关的其他法医临床鉴定）；[03]法医精神病鉴定（[0301]精神状态鉴定）；[01]文书鉴定（[0101]笔迹鉴定、[0102]印章印文鉴定、[0103]印刷文件鉴定、[0104]篡改（污损）文件鉴定、[0105]文件形成方式鉴定、[0106]特种文件鉴定、[0107]朱墨时序鉴定、[0109]基于痕迹特征的文件形成时间鉴定、[0111]文本内容鉴定）；[02]痕迹鉴定（[0201]手印鉴定、[0203]足迹鉴定、[0211]交通事故痕迹物证鉴定）；[01]录音鉴定；[02]图像鉴定（[0201]图像处理、[0202]图像真实性鉴定、[0203]图像同一性鉴定、[0204]图像内容分析）；[03]电子数据鉴定"
  },
  "440318295": {
    "JGZSXXDZ": "广东省深圳市罗湖区桂园街道深南东路5016号京基100大厦八楼和901室",
    "JGLXDH": "0755-82289002"
  }
};

export const memberInstitutionOverridesByName = {
  "广东财安司法鉴定所": {
    "YWFW": "[02]法医临床鉴定（[0201]人体损伤程度鉴定、[0202]人体残疾等级鉴定、[0203]赔偿相关鉴定、[0206]诈伤、诈病、造作伤鉴定、[0209]与人体损伤相关的其他法医临床鉴定）；[01]文书鉴定（[0101]笔迹鉴定、[0102]印章印文鉴定、[0103]印刷文件鉴定、[0104]篡改（污损）文件鉴定、[0105]文件形成方式鉴定、[0106]特种文件鉴定、[0107]朱墨时序鉴定、[0109]基于痕迹特征的文件形成时间鉴定、[0111]文本内容鉴定）；[02]痕迹鉴定（[0201]手印鉴定、[0202]潜在手印显现、[0203]足迹鉴定、[0204]工具痕迹鉴定、[0205]整体分离痕迹鉴定）；[01]录音鉴定（[0101]录音处理、[0102]录音真实性鉴定、[0103]录音同一性鉴定）；[02]图像鉴定（[0201]图像处理、[0202]图像真实性鉴定、[0203]图像同一性鉴定）；[03]电子数据鉴定（[0301]电子数据存在性鉴定）"
  },
  "广东南天司法鉴定所": {
    "YWFW": "[01]法医病理鉴定；[02]法医临床鉴定；[03]法医精神病鉴定（[0301]精神状态鉴定、[0302]刑事类行为能力鉴定、[0303]民事类行为能力鉴定、[0304]其他类行为能力鉴定、[0305]精神损伤类鉴定、[0309]与心理、精神相关的其他法医精神病鉴定或测试）；[04]法医物证鉴定（[0401]个体识别、[0402]三联体亲子关系鉴定、[0403]二联体亲子关系鉴定、[0404]亲缘关系鉴定[祖孙关系鉴定、生物学全同胞关系鉴定]）；[05]法医毒物鉴定；[01]文书鉴定；[02]痕迹鉴定（[0201]手印鉴定、[0202]潜在手印显现、[0203]足迹鉴定、[0204]工具痕迹鉴定、[0205]整体分离痕迹鉴定、[0207]爆炸痕迹鉴定、[0208]火灾痕迹鉴定、[0209]人体特殊痕迹鉴定、[0210]日用物品损坏痕迹鉴定、[0211]交通事故痕迹物证鉴定）；[03]微量物证鉴定（[0301]化工产品类鉴定、[0302]金属和矿物类鉴定、[0303]纺织品类鉴定、[0304]日用化学品类鉴定、[0305]文化用品类鉴定、[0307]易燃物质类鉴定、[0310]交通事故微量物证鉴定、[0311]火灾微量物证鉴定）；[01]录音鉴定（[0101]录音处理、[0102]录音真实性鉴定、[0103]录音同一性鉴定、[0104]录音内容分析）；[02]图像鉴定（[0201]图像处理、[0202]图像真实性鉴定、[0203]图像同一性鉴定、[0204]图像内容分析）；[03]电子数据鉴定；[02]地表水与沉积物环境损害鉴定（[0201]污染环境行为致地表水与沉积物环境损害鉴定）；[05]近岸海洋与海岸带环境损害鉴定；[06]生态系统环境损害鉴定（[0601]生态破坏行为致植物损害鉴定、[0602]生态破坏行为致动物损害鉴定、[0604]生态破坏行为致森林生态系统损害鉴定、[0608]生态破坏行为致海洋生态系统损害鉴定、[0609]生态破坏行为致河流、湖泊生态系统损害鉴定、[0611]生态破坏行为致农田生态系统损害鉴定、[0612]生态破坏行为致城市生态系统损害鉴定、[0613]矿产资源开采行为致矿山地质环境破坏、土地损毁及生态功能损害鉴定）"
  },
  "广东安证计算机司法鉴定所": {
    "JGZSXXDZ": "深圳市兴海大道信利康大厦13F"
  },
  "广东龙城司法鉴定所": {
    "YWFW": "[01]法医病理鉴定（[0101]死亡原因鉴定、[0102]器官组织法医病理学检验与诊断、[0103]死亡方式判断、[0104]死亡时间推断、[0105]损伤时间推断、[0106]致伤物推断、[0107]成伤机制分析）；[02]法医临床鉴定（[0201]人体损伤程度鉴定、[0202]人体残疾等级鉴定、[0203]赔偿相关鉴定、[0206]诈伤、诈病、造作伤鉴定、[0207]医疗损害鉴定、[0209]与人体损伤相关的其他法医临床鉴定）；[01]文书鉴定（[0101]笔迹鉴定、[0102]印章印文鉴定、[0103]印刷文件鉴定、[0104]篡改（污损）文件鉴定、[0105]文件形成方式鉴定、[0107]朱墨时序鉴定、[0111]文本内容鉴定）；[03]电子数据鉴定（[0301]电子数据存在性鉴定）"
  },
  "广东公标知识产权司法鉴定所": {
    "JGZSXXDZ": "深圳市南山区梦海大道中粮亚太大厦东塔24层2403"
  },
  "广东华亿司法鉴定所": {
    "YWFW": "[02]法医临床鉴定（[0201]人体损伤程度鉴定、[0202]人体残疾等级鉴定、[0203]赔偿相关鉴定、[0207]医疗损害鉴定、[0209]与人体损伤相关的其他法医临床鉴定）；[03]法医精神病鉴定（[0301]精神状态鉴定）；[01]文书鉴定（[0101]笔迹鉴定、[0102]印章印文鉴定、[0103]印刷文件鉴定、[0104]篡改（污损）文件鉴定、[0105]文件形成方式鉴定、[0106]特种文件鉴定、[0107]朱墨时序鉴定、[0109]基于痕迹特征的文件形成时间鉴定、[0111]文本内容鉴定）；[02]痕迹鉴定（[0201]手印鉴定、[0203]足迹鉴定、[0211]交通事故痕迹物证鉴定）；[01]录音鉴定；[02]图像鉴定（[0201]图像处理、[0202]图像真实性鉴定、[0203]图像同一性鉴定、[0204]图像内容分析）；[03]电子数据鉴定"
  },
  "深圳市环境科学研究院环境损害司法鉴定所": {
    "JGZSXXDZ": "广东省深圳市罗湖区桂园街道深南东路5016号京基100大厦八楼和901室",
    "JGLXDH": "0755-82289002"
  }
};

/**
 * 将接口返回的机构列表按 Excel 实质差异覆盖后返回
 * @param {Array} list
 * @returns {Array}
 */
export function applyMemberInstitutionOverrides(list) {
  if (!Array.isArray(list)) return list;
  return list.map((item) => {
    if (!item) return item;
    const byLicense =
      memberInstitutionOverridesByLicense[String(item.SFJDJGXKZH || "").trim()];
    const byName =
      memberInstitutionOverridesByName[String(item.SFJDJGMC || "").trim()];
    const patch = byLicense || byName;
    if (!patch) return item;
    return Object.assign({}, item, patch);
  });
}
